import React, { Component } from 'react';

// style
import "./ArtWork.scss";

/**
 * @see     /public/data.json
 *          /src/components/bootstrap/cards
 */
class ArtWork extends Component {

	render() {
		let url = this.props.art.url;
		if (window.ING_Art_language !== 'en') {
			url = `/${window.ING_Art_language}${this.props.art.url}`;
		}

		return (
			<>
				<a href={url} title={"Visit \"" + this.props.art.title + "\" by " + this.props.art.artist}>
					<div className="artwork-wrapper">
						<div className="placeholder">
							<img src={this.props.art.images.banner} className="art-img-top" alt={this.props.art.title} />
						</div>
						<div className="art-body">
							<p className="caption bold"><strong>{this.props.art.artist}</strong></p>
							<p className="caption">{this.props.art.title}</p>
						</div>
					</div>
				</a>
			</>
		)
	}
}

export default ArtWork;